import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import { validateShippingFields } from "MODULES/PurchaseOrders/shared/validations";
import { BUYING_STORE_ID } from "MODULES/PurchaseOrders/constants";
import {
  BUYER_CREDIT_PCT,
  COMPANY_ID,
  CONTACT_ID,
  COST,
  FOB,
  NAME,
  PAYMENT_TERMS
} from "APP_ROOT/constants";
import { BUYER_ID } from "MODULES/users/constants";
import { COST_SPLIT, LOT_TYPE } from "MODULES/Lots/constants";
import { LEAD_TIME } from "MODULES/inventories/constants";

export default function validate(values, props) {
  return validator(values, v => {
    v
      .validate(
        BUYING_STORE_ID,
        COMPANY_ID,
        CONTACT_ID,
        COST,
        LEAD_TIME,
        LOT_TYPE,
        NAME,
        PAYMENT_TERMS,
        BUYER_ID,
        BUYER_CREDIT_PCT,
        FOB
      )
      .satisfies(rules.required);

    validateShippingFields(values, v);

    v
      .validate(COST_SPLIT)
      .satisfies(
        rules.isGreaterThanOrEqualTo(0),
        rules.isLessThanOrEqualTo(100)
      );

    if (props.selectedCompany) {
      v
        .validate(COMPANY_ID)
        .satisfies(() => rules.validateCompanyStatus(props.selectedCompany));
    }
  });
}



// WEBPACK FOOTER //
// ./app/modules/Lots/Create/validate.js